import React, { Grid, Typography, Divider } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { StatisticsProps } from "./StatisticsProps";

export const Statistics = ({ status, title }: StatisticsProps) => {
    return(<>
        { status && (
            <>
                <Typography variant='h6' padding={1}>
                    {title}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Grid container justifyContent={'space-between'} padding={2}>
                    <Typography variant='subtitle2'>Sales:</Typography>
                    <Typography>{status.leftSales}</Typography>
                </Grid>
                <Grid container justifyContent={'space-between'} padding={2}>
                    <Typography variant='subtitle2'>Right Stream Sales:</Typography>
                    <Typography>{status.rightSales}</Typography>
                </Grid>
                <Grid container justifyContent={'space-between'} padding={2}>
                    <Typography variant='subtitle2'>Left Stream Sales:</Typography>
                    <Typography>{status.leftSales}</Typography>
                </Grid>
                <Grid container justifyContent={'space-between'} padding={2}>
                    <Typography variant='subtitle2'>BP Points:</Typography>
                    <Typography>{status?.leftBPPoints + status?.rightBPPoints + status?.bpPoints}</Typography>
                </Grid>
                <Grid container justifyContent={'space-between'} padding={2}>
                    <Typography variant='subtitle2'>PP Points:</Typography>
                    <Typography>{status.ppPoints ?? 0}</Typography>
                </Grid>
                <Grid container padding={2}>
                    <PieChart
                        series={[
                            {
                                data: [
                                    { id: 0, value: status.leftBPPoints, label: 'Left BP Points' },
                                    { id: 1, value: status.rightBPPoints, label: 'Right BP Points' },
                                ],
                            },
                        ]}
                        height={200}
                    />
                </Grid>
            </>
        )}
    </>)
}